import axios from 'ggApp/utils/requests';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store';
import * as at from '../actionTypes';

export const getPaymentMethodsByStore = () => (dispatch, getState) => {
    const { code } = activeStoreSelector(getState());
    return dispatch({
        type: 'GET_PAYMENT_METHODS_BY_STORE',
        promise: axios
            .get(`/stores/${code}/payment_methods`)
            .then((res) => res.data.payment_method),
    });
};

export function setActiveStorePaymentMethodId(id) {
    return {
        type: 'SET_ACTIVE_STORE_PAYMENT_METHOD_ID',
        id,
    };
}

export function getPaymentMethodsByUser() {
    return (dispatch) =>
        dispatch({
            type: 'GET_PAYMENT_METHODS_BY_USER',
            promise: axios.get('/user/payment_methods').then((res) => res.data.payment_methods),
        });
}

export function setActiveUserPaymentMethodId(id) {
    return {
        type: 'SET_ACTIVE_USER_PAYMENT_METHOD_ID',
        id,
    };
}

export function startFetching() {
    return {
        type: 'PAYMENT_FETCHING',
    };
}

export function stopFetching() {
    return {
        type: 'PAYMENT_STOP_FETCHING',
    };
}

// Oneclick Adyen payment
export function getAdyenPaymentInfo(ref) {
    return (dispatch) => {
        dispatch({ type: at.GET_ADYEN_PAYMENT_INFO });
        return axios
            .get(`/adyen/onetimes/${ref}`)
            .then((result) => {
                dispatch({
                    type: at.GET_ADYEN_PAYMENT_INFO_SUCCESS,
                    data: result.data,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: at.GET_ADYEN_PAYMENT_INFO_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}

export function createAdyenPaymentSession(ref) {
    return (dispatch) => {
        dispatch({ type: at.CREATE_ADYEN_PAYMENT_SESSION });
        return axios
            .post(`/adyen/onetimes/${ref}/sessions`, {})
            .then((result) => {
                dispatch({
                    type: at.CREATE_ADYEN_PAYMENT_SESSION_SUCCESS,
                    data: result.data,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: at.CREATE_ADYEN_PAYMENT_SESSION_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}

export function submitAdyenPaymentDetails(ref, details) {
    return (dispatch) => {
        dispatch({ type: at.SUBMIT_ADYEN_PAYMENT_DETAILS });
        return axios
            .post(`/adyen/onetimes/${ref}/details`, { redirect_result: details })
            .then((result) => {
                dispatch({
                    type: at.SUBMIT_ADYEN_PAYMENT_DETAILS_SUCCESS,
                    data: result.data,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: at.SUBMIT_ADYEN_PAYMENT_DETAILS_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}
